export var InternalEventType;
(function (InternalEventType) {
    InternalEventType["CONTAINED"] = "CONTAINED";
    InternalEventType["FILTERS_CLICKED"] = "FILTERS_CLICKED";
    InternalEventType["FORM_SUBMITTED"] = "FORM_SUBMITTED";
    InternalEventType["REDIRECTED"] = "REDIRECTED";
    InternalEventType["VIEWED"] = "VIEWED";
})(InternalEventType || (InternalEventType = {}));
